import React, { useState } from "react";
import { Grid, Button, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { headers } from "../../utils/utils";

const BoardConfig = ({ boards, setBoards, fetchBoards }) => {
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [newBoardLabel, setNewBoardLabel] = useState("");
  const handleBoardSelect = (board) => {
    localStorage.setItem("board", board.id);
    window.location.reload();

  };
  const handleAddBoard = async () => {
    if (newBoardLabel.trim()) {
      const newBoard = {
        value: newBoardLabel,
        groupName: "Board",
      };

      try {
        const response = await fetch(
          process.env.REACT_APP_SYS_CONFIG_MGMT + "/systemConfig/save",
          {
            method: "POST",
            headers: headers(),
            body: JSON.stringify(newBoard),
          },
        );

        if (response.ok) {
          const savedBoard = await response.json();
          setBoards([...boards, savedBoard]);
          setNewBoardLabel("");
          setIsInputVisible(false);
          fetchBoards();
          if (boards.length === 0) {
            localStorage.setItem("board", savedBoard.id);
          }
        } else {
          console.error("Failed to save the board:", response.statusText);
        }
      } catch (error) {
        console.error("Error saving the board:", error);
      }
    }
  };

  const handleDeleteBoard = async (id) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SYS_CONFIG_MGMT + `/systemConfig/update/${id}`,
        {
          method: "PUT",
          headers: headers(),
          body: JSON.stringify({ active: false }),
        },
      );

      if (response.ok) {
        setBoards(boards.filter((board) => board.id !== id));
        fetchBoards();
      } else {
        console.error("Failed to delete board:", response.statusText);
      }
    } catch (error) {
      console.error("Error while deleting board:", error);
    }
  };

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      {boards &&
        boards.length > 0 &&
        boards.map((board) => (
          <Grid
            item
            key={board.id}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="outlined"
              sx={{
                minWidth: "120px",
                color: "#696969",
                borderColor: "#696969",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#A9A9A9",
                  borderColor: "#A9A9A9",
                },
              }}
              endIcon={
                <DeleteIcon
                  onClick={() => handleDeleteBoard(board.id)}
                  sx={{ color: "#e74c3c", cursor: "pointer" }}
                />
              }

            >
              <span onClick={() => handleBoardSelect(board)}>
                {board.value}
              </span>
            </Button>
          </Grid>
        ))}

      <Grid item style={{ position: "relative", width: "120px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {!isInputVisible ? (
            <Button
              variant="contained"
              color="success"
              style={{ minWidth: "100%" }}
              onClick={() => setIsInputVisible(true)}
            >
              +
            </Button>
          ) : (
            <TextField
              variant="outlined"
              size="small"
              value={newBoardLabel}
              onChange={(e) => setNewBoardLabel(e.target.value)}
              placeholder="Enter new board"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleAddBoard();
                }
              }}
              onBlur={() => setIsInputVisible(false)}
              autoFocus
              sx={{ width: "100%" }}
            />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default BoardConfig;
